export const POST_SIGNOZ_ENABLE_DISABLE_ALERTS = "POST_SIGNOZ_ENABLE_DISABLE_ALERTS";
export const POST_SIGNOZ_ENABLE_DISABLE_ALERTS_SUCCESS = "POST_SIGNOZ_ENABLE_DISABLE_ALERTS_SUCCESS";
export const POST_SIGNOZ_ENABLE_DISABLE_ALERTS_FAIL = "POST_SIGNOZ_ENABLE_DISABLE_ALERTS_FAIL";

export const POST_ENABLE_DISABLE_SIGNOZ_THRESHOLD = "POST_ENABLE_DISABLE_SIGNOZ_THRESHOLD";
export const POST_ENABLE_DISABLE_SIGNOZ_THRESHOLD_FAIL = "POST_ENABLE_DISABLE_SIGNOZ_THRESHOLD_FAIL";
export const POST_ENABLE_DISABLE_SIGNOZ_THRESHOLD_SUCCESS = "POST_ENABLE_DISABLE_SIGNOZ_THRESHOLD_SUCCESS";

export const POST_SIGNOZ_CREATE_RESOURCE_ALERTS = "POST_SIGNOZ_CREATE_RESOURCE_ALERTS";
export const POST_SIGNOZ_CREATE_RESOURCE_ALERTS_SUCCESS = "POST_SIGNOZ_CREATE_RESOURCE_ALERTS_SUCCESS";
export const POST_SIGNOZ_CREATE_RESOURCE_ALERTS_FAIL = "POST_SIGNOZ_CREATE_RESOURCE_ALERTS_FAIL";

export const POST_SIGNOZ_CREATE_DYNAMIC_ALERT = "POST_SIGNOZ_CREATE_DYNAMIC_ALERT";
export const POST_SIGNOZ_CREATE_DYNAMIC_ALERT_SUCCESS = "POST_SIGNOZ_CREATE_DYNAMIC_ALERT_SUCCESS";
export const POST_SIGNOZ_CREATE_DYNAMIC_ALERT_FAIL = "POST_SIGNOZ_CREATE_DYNAMIC_ALERT_FAIL";

export const GET_SIGNOZ_ALERTS = "GET_SIGNOZ_ALERTS";
export const GET_SIGNOZ_ALERTS_SUCCESS = "GET_SIGNOZ_ALERTS_SUCCESS";
export const GET_SIGNOZ_ALERTS_FAIL = "GET_SIGNOZ_ALERTS_FAIL";

export const GET_SIGNOZ_DYNAMIC_ALERTS = "GET_SIGNOZ_DYNAMIC_ALERTS";
export const GET_SIGNOZ_DYNAMIC_ALERTS_FAIL = "GET_SIGNOZ_DYNAMIC_ALERTS_FAIL";
export const GET_SIGNOZ_DYNAMIC_ALERTS_SUCCESS = "GET_SIGNOZ_DYNAMIC_ALERTS_SUCCESS";

export const GET_SIGNOZ_MISSING_DYNAMIC_ALERTS = "GET_SIGNOZ_MISSING_DYNAMIC_ALERTS";
export const GET_SIGNOZ_MISSING_DYNAMIC_ALERTS_FAIL = "GET_SIGNOZ_MISSING_DYNAMIC_ALERTS_FAIL";
export const GET_SIGNOZ_MISSING_DYNAMIC_ALERTS_SUCCESS = "GET_SIGNOZ_MISSING_DYNAMIC_ALERTS_SUCCESS";

export const GET_SIGNOZ_DEFAULT_THRESHOLD = "GET_SIGNOZ_DEFAULT_THRESHOLD";
export const GET_SIGNOZ_DEFAULT_THRESHOLD_FAIL = "GET_SIGNOZ_DEFAULT_THRESHOLD_FAIL";
export const GET_SIGNOZ_DEFAULT_THRESHOLD_SUCCESS = "GET_SIGNOZ_DEFAULT_THRESHOLD_SUCCESS";

export const GET_SIGNOZ_THRESHOLD = "GET_SIGNOZ_THRESHOLD";
export const GET_SIGNOZ_THRESHOLD_SUCCESS = "GET_SIGNOZ_THRESHOLD_SUCCESS";
export const GET_SIGNOZ_THRESHOLD_FAIL = "GET_SIGNOZ_THRESHOLD_FAIL";

export const GET_SIGNOZ_RESOURCE_BY_ID = "GET_SIGNOZ_RESOURCE_BY_ID";
export const GET_SIGNOZ_RESOURCE_BY_ID_SUCCESS = "GET_SIGNOZ_RESOURCE_BY_ID_SUCCESS";
export const GET_SIGNOZ_RESOURCE_BY_ID_FAIL = "GET_SIGNOZ_RESOURCE_BY_ID_FAIL";

export const GET_SIGNOZ_RESOURCE_DEFAULT_THRESHOLD_BY_ID = "GET_SIGNOZ_RESOURCE_DEFAULT_THRESHOLD_BY_ID";
export const GET_SIGNOZ_RESOURCE_DEFAULT_THRESHOLD_BY_ID_SUCCESS = "GET_SIGNOZ_RESOURCE_DEFAULT_THRESHOLD_BY_ID_SUCCESS";
export const GET_SIGNOZ_RESOURCE_DEFAULT_THRESHOLD_BY_ID_FAIL = "GET_SIGNOZ_RESOURCE_DEFAULT_THRESHOLD_BY_ID_FAIL";

export const POST_SIGNOZ_ALERT = "POST_SIGNOZ_ALERT";
export const POST_SIGNOZ_ALERT_SUCCESS = "POST_SIGNOZ_ALERT_SUCCESS";
export const POST_SIGNOZ_ALERT_FAIL = "POST_SIGNOZ_ALERT_FAIL";

export const GET_SIGNOZ_RESCAN = "GET_SIGNOZ_RESCAN";
export const GET_SIGNOZ_RESCAN_FAIL = "GET_SIGNOZ_RESCAN_FAIL";
export const GET_SIGNOZ_RESCAN_SUCCESS = "GET_SIGNOZ_RESCAN_SUCCESS";

export const GET_SIGNOZ_MISSING_ALERT_BY_RESOURCE_ID = "GET_MISSING_ALERT_BY_RESOURCE_ID";
export const GET_SIGNOZ_MISSING_ALERT_BY_RESOURCE_ID_FAIL = "GET_MISSING_ALERT_BY_RESOURCE_ID_FAIL";
export const GET_SIGNOZ_MISSING_ALERT_BY_RESOURCE_ID_SUCCESS = "GET_MISSING_ALERT_BY_RESOURCE_ID_SUCCESS";

export const GET_SIGNOZ_ALL_RESOURCE_ALERTS_PAGE = "GET_SIGNOZ_ALL_RESOURCE_ALERTS_PAGE";
export const GET_SIGNOZ_ALL_RESOURCE_ALERTS_PAGE_FAIL = "GET_SIGNOZ_ALL_RESOURCE_ALERTS_PAGE_FAIL";
export const GET_SIGNOZ_ALL_RESOURCE_ALERTS_PAGE_SUCCESS = "GET_SIGNOZ_ALL_RESOURCE_ALERTS_PAGE_SUCCESS";

export const GET_SIGNOZ_ALL_RESOURCE_ALERTS_COUNT_PAGE = "GET_SIGNOZ_ALL_RESOURCE_ALERTS_COUNT_PAGE";
export const GET_SIGNOZ_ALL_RESOURCE_ALERTS_COUNT_PAGE_FAIL = "GET_SIGNOZ_ALL_RESOURCE_ALERTS_COUNT_PAGE_FAIL";
export const GET_SIGNOZ_ALL_RESOURCE_ALERTS_COUNT_PAGE_SUCCESS = "GET_SIGNOZ_ALL_RESOURCE_ALERTS_COUNT_PAGE_SUCCESS";

export const GET_SIGNOZ_ALL_BUSINESS_TRANSACTIONS = "GET_SIGNOZ_ALL_BUSINESS_TRANSACTIONS";
export const GET_SIGNOZ_ALL_BUSINESS_TRANSACTIONS_FAIL = "GET_SIGNOZ_ALL_BUSINESS_TRANSACTIONS_FAIL";
export const GET_SIGNOZ_ALL_BUSINESS_TRANSACTIONS_SUCCESS = "GET_SIGNOZ_ALL_BUSINESS_TRANSACTIONS_SUCCESS";

export const GET_SIGNOZ_ALL_EXTERNAL_SERVICES = "GET_SIGNOZ_ALL_EXTERNAL_SERVICES";
export const GET_SIGNOZ_ALL_EXTERNAL_SERVICES_FAIL = "GET_SIGNOZ_ALL_EXTERNAL_SERVICES_FAIL";
export const GET_SIGNOZ_ALL_EXTERNAL_SERVICES_SUCCESS = "GET_SIGNOZ_ALL_EXTERNAL_SERVICES_SUCCESS";

export const POST_SIGNOZ_SERVICE_MAPPING = "POST_SIGNOZ_SERVICE_MAPPING";
export const POST_SIGNOZ_SERVICE_MAPPING_FAIL = "POST_SIGNOZ_SERVICE_MAPPING_FAIL";
export const POST_SIGNOZ_SERVICE_MAPPING_SUCCESS = "POST_SIGNOZ_SERVICE_MAPPING_SUCCESS";

export const POST_SIGNOZ_RESOURCE_OPSGENIE_TEAM_MAPPING = "POST_SIGNOZ_RESOURCE_OPSGENIE_TEAM_MAPPING";
export const POST_SIGNOZ_RESOURCE_OPSGENIE_TEAM_MAPPING_FAIL = "POST_SIGNOZ_RESOURCE_OPSGENIE_TEAM_MAPPING_FAIL";
export const POST_SIGNOZ_RESOURCE_OPSGENIE_TEAM_MAPPING_SUCCESS = "POST_SIGNOZ_RESOURCE_OPSGENIE_TEAM_MAPPING_SUCCESS";

export const POST_SIGNOZ_RESOURCE_PAGERDUTY_SERVICE_MAPPING = "POST_SIGNOZ_RESOURCE_PAGERDUTY_SERVICE_MAPPING";
export const POST_SIGNOZ_RESOURCE_PAGERDUTY_SERVICE_MAPPING_FAIL = "POST_SIGNOZ_RESOURCE_PAGERDUTY_SERVICE_MAPPING_FAIL";
export const POST_SIGNOZ_RESOURCE_PAGERDUTY_SERVICE_MAPPING_SUCCESS = "POST_SIGNOZ_RESOURCE_PAGERDUTY_SERVICE_MAPPING_SUCCESS";
 ////////////////////////////////////////////////////////
export const GET_SIGNOZ_RESOURCES = "GET_SIGNOZ_RESOURCES";
export const GET_SIGNOZ_RESOURCES_FAIL = "GET_SIGNOZ_RESOURCES_FAIL";
export const GET_SIGNOZ_RESOURCES_SUCCESS = "GET_SIGNOZ_RESOURCES_SUCCESS";

export const GET_ALL_ORG_SIGNOZ_RESOURCE_TYPES = "GET_ALL_ORG_SIGNOZ_RESOURCE_TYPES";
export const GET_ALL_ORG_SIGNOZ_RESOURCE_TYPES_SUCCESS = "GET_ALL_ORG_SIGNOZ_RESOURCE_TYPES_SUCCESS";
export const GET_ALL_ORG_SIGNOZ_RESOURCE_TYPES_FAIL = "GET_ALL_ORG_SIGNOZ_RESOURCE_TYPES_FAIL";

export const GET_RESCAN_STATUS_SIGNOZ = "GET_RESCAN_STATUS_SIGNOZ";
export const GET_RESCAN_STATUS_SIGNOZ_FAIL = "GET_RESCAN_STATUS_SIGNOZ_FAIL";
export const GET_RESCAN_STATUS_SIGNOZ_SUCCESS = "GET_RESCAN_STATUS_SIGNOZ_SUCCESS";

export const POST_UPDATE_SIGNOZ_THRESHOLD = "POST_UPDATE_SIGNOZ_THRESHOLD";
export const POST_UPDATE_SIGNOZ_THRESHOLD_FAIL = "POST_UPDATE_SIGNOZ_THRESHOLD_FAIL";
export const POST_UPDATE_SIGNOZ_THRESHOLD_SUCCESS = "POST_UPDATE_SIGNOZ_THRESHOLD_SUCCESS"

export const GET_SIGNOZ_MISSING_ALERTS_BY_RESOURCE_ID = "GET_SIGNOZ_MISSING_ALERTS_BY_RESOURCE_ID";
export const GET_SIGNOZ_MISSING_ALERTS_BY_RESOURCE_ID_SUCCESS = "GET_SIGNOZ_MISSING_ALERTS_BY_RESOURCE_ID_SUCCESS";
export const GET_SIGNOZ_MISSING_ALERTS_BY_RESOURCE_ID_FAIL = "GET_SIGNOZ_MISSING_ALERTS_BY_RESOURCE_ID_FAIL";

export const GET_SIGNOZ_NON_KEY_TRANSACTIONS = "GET_SIGNOZ_NON_KEY_TRANSACTIONS";
export const GET_SIGNOZ_NON_KEY_TRANSACTIONS_SUCCESS = "GET_SIGNOZ_NON_KEY_TRANSACTIONS_SUCCESS";
export const GET_SIGNOZ_NON_KEY_TRANSACTIONS_FAIL = "GET_SIGNOZ_NON_KEY_TRANSACTIONS_FAIL";

export const POST_MARK_SIGNOZ_NON_KEY_TRANSACTION_AS_BUSINESS_TRANSACTION = "POST_MARK_SIGNOZ_NON_KEY_TRANSACTION_AS_BUSINESS_TRANSACTION";
export const POST_MARK_SIGNOZ_NON_KEY_TRANSACTION_AS_BUSINESS_TRANSACTION_SUCCESS = "POST_MARK_SIGNOZ_NON_KEY_TRANSACTION_AS_BUSINESS_TRANSACTION_SUCCESS";
export const POST_MARK_SIGNOZ_NON_KEY_TRANSACTION_AS_BUSINESS_TRANSACTION_FAIL = "POST_MARK_SIGNOZ_NON_KEY_TRANSACTION_AS_BUSINESS_TRANSACTION_FAIL";



